import React from 'react';
import { Heart } from 'lucide-react';

// Heart + count. `likes` comes from the useLikes hook in App.
const LikeButton = ({ paintingId, likes, onToggle, size = 'sm' }) => {
  if (!likes.available) return null;
  const liked = likes.mine.has(paintingId);
  const count = likes.counts[paintingId] || 0;
  const big = size === 'lg';
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onToggle(paintingId); }}
      className={`inline-flex items-center gap-1 rounded-full transition-colors ${
        big ? 'px-4 py-2 border border-red-200 hover:bg-red-50' : 'px-1.5 py-0.5 hover:bg-red-50'
      } ${liked ? 'text-red-500' : 'text-gray-500 hover:text-red-500'}`}
      title={liked ? 'Unlike' : 'Like this painting'}
      aria-pressed={liked}
    >
      <Heart size={big ? 18 : 13} className={liked ? 'fill-red-500' : ''} />
      <span className={big ? 'text-sm font-medium' : 'text-[11px]'}>{count}</span>
      {big && <span className="text-sm">{liked ? 'Liked' : 'Like'}</span>}
    </button>
  );
};

export default LikeButton;
